import { render } from "./batchAccountClosure.vue?vue&type=template&id=3bd573d7&scoped=true"
import script from "./batchAccountClosure.vue?vue&type=script&lang=js"
export * from "./batchAccountClosure.vue?vue&type=script&lang=js"

import "./batchAccountClosure.vue?vue&type=style&index=0&id=3bd573d7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3bd573d7"

export default script